module.exports = __webpack_public_path__ + "media/images/haircut/main_image1@3x-0fa99acf8a08b65a7ed56c2489a03ae1.jpg";